<div
  class="ai-audit-backdrop"
  *ngIf="audit"
  role="button"
  tabindex="0"
  aria-label="Close prompt audit"
  (click)="closeOnBackdrop($event)"
  (keydown.enter)="closeRequested.emit()"
  (keydown.space)="closeRequested.emit()"
>
  <section class="ai-audit-dialog" role="dialog" aria-modal="true">
    <header>
      <div>
        <small>Prompt Audit</small>
        <h3>{{ audit.id }}</h3>
      </div>
      <button type="button" aria-label="Close prompt audit" (click)="closeRequested.emit()">
        <i class="ki-filled ki-cross"></i>
      </button>
    </header>

    <div class="ai-audit-grid">
      <article>
        <span>System prompt</span>
        <p>{{ audit.systemPrompt }}</p>
      </article>
      <article>
        <span>User prompt</span>
        <p>{{ audit.userPrompt }}</p>
      </article>
      <article>
        <span>Intent and tool</span>
        <p>{{ audit.interpretedIntent }} / {{ audit.tool }}</p>
      </article>
      <article>
        <span>Payload</span>
        <pre>{{ audit.payload | json }}</pre>
      </article>
    </div>
  </section>
</div>
